import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { ReactComponent as Warning } from '../../../assets/icons/warning-icon.svg';
import { Button } from '../../Buttons/Button';
import { Container, Content } from './style';

interface ModalOption {
  active?: boolean;
  text?: string;
}

interface dataModal {
  title: string;
  text: string;
  optionCancel?: ModalOption;
  optionConfirm?: ModalOption;
  type: 'warning' | 'generic';
}

interface ModalAlertConfirmationProps {
  isOpen: boolean;
  data: dataModal;
  onRequestClose: () => void;
  onConfirm: () => void;
}

export function ModalAlertConfirmation({
  isOpen,
  data,
  onRequestClose,
  onConfirm,
}: ModalAlertConfirmationProps) {
  const handleOnConfirm = () => {
    onConfirm();
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-alert-modal-content">
      <Container>
        <Content type={data.type}>
          <div className="subHeader">
            <div>
              <h1>
                <Warning /> {data.title}
              </h1>
              <p>{data.text}</p>
            </div>
          </div>
          <div className="close-div">
            <button type="button" onClick={onRequestClose}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </Content>
        <div className="buttons">
          {data.optionCancel?.active !== false && (
            <Button
              text={data.optionCancel?.text ?? 'Cancelar'}
              dimensions={{
                width: '10rem',
                height: '2rem',
              }}
              color="tertiary_500"
              backgroundHoverColor="tertiary_500"
              textHoverColor="background_white"
              border={{ color: 'tertiary_500', width: 1 }}
              onClick={onRequestClose}
            />
          )}
          {data.optionConfirm?.active !== false && (
            <Button
              text={data.optionConfirm?.text ?? 'Confirmar'}
              dimensions={{
                width: '10rem',
                height: '2rem',
              }}
              background="secondary"
              backgroundHoverColor="primary"
              onClick={handleOnConfirm}
            />
          )}
        </div>
      </Container>
    </Modal>
  );
}
